import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconSmsTan = (iconProps: ChkIconProps) => (
  <ChkSvgWrapper {...iconProps}>
    <g>
      <path
        d="M20 12.7327V15.0814C20 15.9098 19.3284 16.5814 18.5 16.5814H8.3232C7.99556 16.5814 7.67692 16.6887 7.416 16.8868L2 21V16.5814V6.5C2 5.67157 2.67157 5 3.5 5H12.232"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <circle cx="20" cy="5" r="3" stroke="currentColor" strokeWidth="2" />
    </g>
  </ChkSvgWrapper>
);
